import { InfoCircleFilled } from "@ant-design/icons"
import { Checkbox, Tooltip } from "antd"
import { PURPLE,ERROR_RED } from "../../styles/styleUtils"
import UMCAttrComponentView from "../common/UMCAttrComponentView"
import UMCModal from "../common/UMCModal"
import { useEffect, useState, useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import { setCurrModalMergedData, setBaseModalMergeData, setTextFieldErr, setContentLoading, setUmcNotification } from "../../store/reducers/CommonReducer"
import { getMultideviceSchema, getMultideviceData, deleteUser, refreshMultideviceIcons } from "../../store/actions/UUMActions"
import UMCButton from "../common/UMCButton"
import confirmModal from "../common/confirmModal"
import { getThemedImage, getImage, isHTMLString, getTranslated, parseRefAPI } from "../../utils/CommonUtils"
import { checkIfAnyModified, findInObjectById, deepMergeObjects, getAllAttrWithIsLink, updateObjectById, validateLinks } from "../../utils/SchemaParseUtils"
import { setDisableMultiDvcDECTOKBtn, setMultiDeviceData, setMultiDeviceSchema } from "../../store/reducers/UUMReducer"
import parse from 'html-react-parser'
import { updateModelItem } from "../../store/actions/CommonActions"
import { UUM_URL } from "../../utils/Config"
import _ from "lodash"
import SingleImage from "../common/SingleImage"
import { validateSelectedMandatoryAttrs } from "../../utils/ValidationUtils"
import { sendGTMEvent } from "../../utils/GTMUtils"
import { getRequest } from "../../utils/RequestActions"

const MultideviceModal = (props) => {

    // --- State initialization ---
    const [open, setOpen] = useState(props.open)
    const [loading, setLoading] = useState(false)
    const [selectedDevices, setSelectedDevices] = useState([])
    const [validateState, setValidateState] = useState(false)
    const [rainbowMessage, setRainbowMessage] = useState({
        message : '',
        status : ''
    })

    // --- Redux state selectors ---
    const currModalMergedData = useSelector((state) => state.common.currModalMergedData)
    const currentMergedData = useSelector((state) => state.common.currentMergedData)
    const baseModalMergeData = useSelector(state => state.common.baseModalMergeData)
    const multiDeviceData = useSelector((state) => state.uum.MultiDeviceData)
    const multiDeviceSchema = useSelector((state) => state.uum.multiDeviceSchema)
    const disableMultiDvcDECTOKBtn = useSelector((state) => state.uum.disableMultiDvcDECTOKBtn)
    const dict = useSelector((state) => state.common.dict)

    const dispatch = useDispatch()

    // --- Find current user's Directory Number attribute ---
    const dnAttr = findInObjectById(currentMergedData, "directorynumber")


    // --- On mount: fetch schema, and cleanup on unmount ---
    useEffect(() => {
        setLoading(true)

        dispatch(setDisableMultiDvcDECTOKBtn(false))
        dispatch(getMultideviceSchema((response) => {
            // const linkValidatedschema = validateLinks(response.domain)
            dispatch(setMultiDeviceSchema(response))
        }))

        return (() => {
            dispatch(setCurrModalMergedData(null))
            dispatch(setMultiDeviceData(null))
            dispatch(setTextFieldErr({ id: "dectdirectorynumber", status: "" }))
        }) // Reset error status set on dectdirectorynumber field if any 
    }, [])

    // --- When DN changes, fetch user's multidevice data ---
    useEffect(() => {
        dispatch(getMultideviceData(dnAttr.value, (response) => {
            // const linkValidatedschema = validateLinks(response.domain)
            dispatch(setMultiDeviceData(response))
        }))

    }, [dnAttr.value])

    // --- When schema or data changes, merge and process for UI ---
    useEffect(() => {
        if (multiDeviceSchema?.domain && multiDeviceData?.domain) {
            const mergedData = deepMergeObjects(multiDeviceSchema.domain, multiDeviceData.domain)
            const attributeWithLinks = getAllAttrWithIsLink(mergedData)
            const validatedData = validateLinks(mergedData, attributeWithLinks)
            const updatedData = filterGroupAttributes(validatedData, attributeWithLinks)

            dispatch(setCurrModalMergedData(updatedData))
            dispatch(setBaseModalMergeData(updatedData))
            setLoading(false)
        }
    }, [multiDeviceSchema, multiDeviceData])

    // --- Filtering ths groupattribute based on link ---
    const filterGroupAttributes = (mergedData, attributeWithLinks) => {
        const matchedLinks = mergedData[0]?.subdomain[0]?.groupattribute.filter(item =>
            !attributeWithLinks.some(attr => new RegExp(`#${attr.id}#`).test(item.link) && item.link.includes(attr.value))
        )

        /* Upsate the mearged data with the filtered value */
        return mergedData.map(domain => ({
            ...domain,
            subdomain: domain.subdomain.map((sub, index) => {
                /* Apply filtering only to subdomain[0] (id = "left") */
                if (index === 0) {
                    return {
                        ...sub,
                        groupattribute: sub.groupattribute.filter(item =>
                            matchedLinks.some(matched => matched.id === item.id)
                        )
                    }
                }
                return sub
            })
        }))
    }

    // --- Handle closing the modal, with DECT cleanup and unsaved changes check ---
    const handleClose = () => {
        const destroyDECTIfCreated = () => {
            const typeData = findInObjectById(currModalMergedData, "type")
            const baseTypeData = findInObjectById(baseModalMergeData, "type")
            const dectdirectorynumber = findInObjectById(currModalMergedData, "dectdirectorynumber")

            if ((dectdirectorynumber?.buttonaddon?.disabled && !typeData?.buttonaddon?.disabled) ||
                ((typeData?.value && !selectedDevices["dect"]) || (!baseTypeData?.value && typeData?.value))) {
                dispatch(deleteUser(dectdirectorynumber.value, () => {
                    return true //Todo: need to handle status?
                }))
            }

            return true
        }

        // --- If there are unsaved changes, confirm before closing ---
        if (hasChanges()) {
            confirmModal({
                title: "MSG_LEAVE_PAGE",
                content: "MSG_LOSE_CONFIG",
                onOk: () => {
                    destroyDECTIfCreated() // Delete partially created DECT user
                    setOpen(false)
                    props.notifyClose() //Notify it's parent about the modal's close
                }
            })
        } else {
            dispatch(setDisableMultiDvcDECTOKBtn(false)) 
            setOpen(false)
            props.notifyClose() //Notify it's parent about the modal's close
        }
    }

    // --- Handle save: validate, set actions (CREATE/DELETE), and dispatch update ---
    const handleSave = () => {
        setLoading(true)
        // Geting the key of the selectedDevice when it is true
        const selectedDeviceKey = Object.keys(selectedDevices).filter(key => selectedDevices[key] === true)

        // Create a deep copy to avoid mutating state directly
        let currMergeDataCopy = JSON.parse(JSON.stringify(currModalMergedData))
        const validateStatus = validateSelectedMandatoryAttrs(currModalMergedData, selectedDeviceKey) // Returns the validated obj if success, else returns false
        if (validateStatus) {
            setValidateState(false)

            // Send GTM event for multidevice save action
            sendGTMEvent({
                event: "umc_easy_user_config",
                action: "Save in Multidevice popup"
            })

            currMergeDataCopy[0]?.subdomain.forEach((sDomain) => {
                sDomain?.groupattribute.forEach(currData => {

                    const foundinbackup = findInObjectById(baseModalMergeData, currData.id)

                    if (foundinbackup) {
                        // Set action to "CREATE"
                        currData.action = ""; // clear action by default

                        // CASE 1: If it was not in backup and is now selected, then CREATE
                        if (foundinbackup.enable === false && selectedDevices[foundinbackup.id] === true) {
                            const hasValue = currData?.attribute?.some(attr => attr.value !== "") //make sure the user has actually filled something before setting CREATE
                            if (hasValue) {
                                currData.action = "CREATE"
                            }
                        }

                        // CASE 2: If it was in backup and now deselected, then DELETE
                        if (foundinbackup.enable === true && selectedDevices[foundinbackup.id] === false) {
                            currData.action = "DELETE"
                        }

                        // Set action to "UPDATE"
                        // else if (foundinbackup.enable === true && selectedDevices[foundinbackup.id] === true) {
                        //     // const isDataUnchanged = JSON.stringify(currData) === JSON.stringify(foundinbackup)
                        //     const isDataUnchanged = _.isEqual(currData, foundinbackup)
                        //     if (!isDataUnchanged) {
                        //         currData.action = "UPDATE"
                        //     }
                        // }

                        //DECT partial creation scenarios
                        if (currData.id === "dect") {
                            const typeData = findInObjectById(currData?.attribute, "type")
                            const dectdirectorynumber = findInObjectById(currData?.attribute, "dectdirectorynumber")
                            if ((dectdirectorynumber?.buttonaddon?.disabled && !typeData?.buttonaddon?.disabled) ||
                                (typeData?.value && !selectedDevices[currData.id]))
                                currData.action = "DELETE" // DELETE if not registered
                        }
                    }
                })
            })

            // Dispatch the updated state
            dispatch(setCurrModalMergedData(currMergeDataCopy))

            // Put api call CURD Opearation
            dispatch(updateModelItem(`${UUM_URL}/data/easyusermultidevices/${dnAttr.value}`,
                (status, data) => {
                    setLoading(false)
                    if (status) {
                        dispatch(setUmcNotification({ // Notify the chages saved successfully in OXE - CRUMC-672
                            type: "success",
                            message: getTranslated(dict, "LABEL_SAVED"),
                            description: ""
                        }))
                        dispatch(setContentLoading(true))
                        dispatch(refreshMultideviceIcons(dnAttr)) // Multidevice icons refresh in primary user view CRUMC-425

                        //Notify it's parent about the modal's close
                        setOpen(false)
                        props.notifyClose()
                    } else {
                        confirmModal({
                            title: data?.responseCode || getTranslated(dict, "LABEL_FAILED"),
                            okText: getTranslated(dict, "LABEL_CLOSE"),
                            cancelText: getTranslated(dict, "LABEL_CANCEL"),
                            onOk: () => {
                                dispatch(setContentLoading(true))
                                dispatch(refreshMultideviceIcons(dnAttr)) // Multidevice icons refresh in primary user view CRUMC-425
                                //Notify it's parent about the modal's close
                                setOpen(false)
                                props.notifyClose()
                            },
                            content: Object.values(data?.errorResponse || {})[0]?.message || ""
                        })
                    }
                }
                , currMergeDataCopy))
        } else {
            setValidateState(true)
        }
    }

    // --- Handle device checkbox selection/deselection, with DECT special logic ---
    const selectDevice = async (event, data) => {
        const isChecked = event.target.checked
        setValidateState(false)

         if (data.id === "rainbow" && !isChecked) {
            setRainbowMessage({ message: "", status: "" });
        }
        if (data.id === "dect") {
            const type = findInObjectById(currModalMergedData, "type")
            if (isChecked && !type.value) {
                dispatch(setDisableMultiDvcDECTOKBtn(true))
                const updatedData = await updateObjectById(currModalMergedData, "dectdirectorynumber", (data) => {
                    let tempData = _.cloneDeep(data)
                    if (tempData) {
                        tempData.buttonaddon.disabled = isChecked ? false : true // disable validate button
                        tempData.access = isChecked ? "READWRITE" : "READONLY"
                    }

                    return tempData
                })
                dispatch(setCurrModalMergedData(updatedData))
            } else {
                dispatch(setDisableMultiDvcDECTOKBtn(false))
            }
        }else if(data.id === "rainbow" && isChecked){
            const foundObj = findInObjectById(data,'ghostzdevice')
            debouncedRainbowFetchRef.current(foundObj, setRainbowMessage);
        }

        setSelectedDevices((prevSelected) => ({
            ...prevSelected,
            [data.id]: isChecked,
        }))
    }
    //To reduce the API calls by debouncing    
    const debouncedRainbowFetchRef = useRef(
        _.debounce((foundObj, setRainbowMessage) => {
            if (foundObj?.refApi?.apiurl) {
                getRequest({ url: parseRefAPI(foundObj.refApi.apiurl) }, (res, statusOk) => {
                    if (statusOk && res.message) {
                        setRainbowMessage({
                            message: res.message,
                            status: res.status || ""
                        });
                    } else {
                        setRainbowMessage({ message: "", status: "" });
                        console.log("rainbow message api failed");
                    }
                });
            }
        }, 100)
    );

    // --- Helper for getting the image source for a device ---
    const getSrcImage = (image) => {
        if (image.enable === undefined) return null
        if (image.imageIcon)
            return getImage(`${`${image.secondaryIcon}`}`)
        else
            return ""
    }

    const hasChanges = () => {
        if (disableMultiDvcDECTOKBtn) return false; //If DECT is waiting for validation to finish -> Save & Close button disabled.
        if (checkIfAnyModified(currModalMergedData?.[0]?.subdomain?.find(sd => sd.id === "left"))) {
            return true;
        }
        return Object.keys(selectedDevices).some(deviceId => {
            const baseDevice = baseModalMergeData[0]?.subdomain
                .flatMap(sd => sd.groupattribute)
                .find(baseGp => baseGp.id === deviceId);
            return baseDevice?.enable !== selectedDevices[deviceId];
        });
    };

    // --- Render modal footer with Cancel and Save buttons ---
    const getFooter = () => {
        return <div className="sl-footer">
            <UMCButton
                label={getTranslated(dict, "LABEL_CANCEL")}
                onClick={() => handleClose()}
            />
            <UMCButton
                label={ getTranslated(dict, "LABEL_SAVE_&_CLOSE")}
                onClick={() => handleSave()}
                type="primary"
                disabled={disableMultiDvcDECTOKBtn || !hasChanges()}
            />
        </div>
    }

    // --- Determine if an attribute should be read-only based on device selection and previous values ---
    const getIsReadOnly = (gpAttr, attr) => {
        /* Disabling the Dect multidevice attibute */
        // if (gpAttr.id === "dect") return true
        const isDeviceSelected = selectedDevices[gpAttr.id]
        /*checking if user selction done or not */
        if (isDeviceSelected === undefined) return true
        /* checkeing if the value is pre existing ot not  */
        if (isDeviceSelected) {
            const baseAttr = baseModalMergeData[0]?.subdomain[0]?.groupattribute
                ?.find(baseGp => baseGp.id === gpAttr.id)
                ?.attribute?.find(baseA => baseA.id === attr.id)
            /* if value is pre-existing assign the readOnlyOnUpdate value */
            return baseAttr?.value ? attr.readOnlyOnUpdate : false
        }
        /* If the device is not selected, mark as read-only (default view)*/
        return true
    }

    // --- Render block 1 view (e.g., image) for DECT device ---
    const getBlock1View = (gpAttr) => {
        if (gpAttr?.id === "dect") {
            // const typeAttr = gpAttr.attribute.find(attr => attr.id === "type")

            return gpAttr?.imageName ? <SingleImage
                imageData={{ imageName: gpAttr.imageName }}
                className="attr-img-addon"
                height="5em"
                width="5em"
            /> : <></>
        }
        return <></>
    }

    const getcontentView = (domain) => {
        return <div id={props.id} className="mdevice-modal">
            {domain[0].subdomain?.map((sDomain, index) => {

                return <>
                    {(index !== 0) ? <div className="divider-hr"></div> : <></>}
                    <div className="device-subdomain">
                        {sDomain.groupattribute.map(gpAttr => {
                            const isChecked = selectedDevices[gpAttr.id] ?? gpAttr.enable

                            return <div className="device-list">
                                <Checkbox
                                    checked={isChecked}
                                    onChange={(event) => selectDevice(event, gpAttr)}
                                // disabled={gpAttr.id === "dect"}
                                >
                                    <span style={{ position: "relative" }}>
                                        <Tooltip title={isHTMLString(getTranslated(dict,gpAttr.secondaryHelp)) ? parse(getTranslated(dict,gpAttr.secondaryHelp)) : getTranslated(dict,gpAttr.secondaryHelp)}>
                                            <img
                                                src={getThemedImage(`dark-${gpAttr.imageIcon}`)}
                                                alt={gpAttr.imageIcon}
                                                className="gp-heading-img"
                                                style={{ opacity: gpAttr.enable === true ? 1 : 0.5 }}
                                            />
                                            {(gpAttr.secondaryIcon) ? <img src={getSrcImage(gpAttr)} alt="Active Status" class="status-indicator" style={{ position: "absolute", bottom: "-5px", right: "2px", transform: "translateX(-40%)" }}></img> : <></>}
                                        </Tooltip>
                                    </span>
                                    {getTranslated(dict, gpAttr.label)}
                                    <Tooltip title={isHTMLString(getTranslated(dict, gpAttr.help)) ? parse(getTranslated(dict, gpAttr.help)) : getTranslated(dict, gpAttr.help)}>
                                        <InfoCircleFilled style={{ color: PURPLE, paddingLeft: "5px" }} />
                                    </Tooltip>
                                </Checkbox>
                                <div className="rainbow-message">
                                    <div className="content-block">
                                        <div className="block-1"></div>
                                        <div className="block-2">
                                            {gpAttr.id === "rainbow" && isChecked && (
                                                rainbowMessage.status === "Info" ? (
                                                    <span className="rainbow-info" style={{ color: PURPLE }}>{rainbowMessage.message}</span>
                                                ) : rainbowMessage.status === "Warning" ? (
                                                    <span className="rainbow-warning" style={{ color: "red" }}>
                                                    <InfoCircleFilled style={{ color: ERROR_RED, paddingRight: "5px", transform: 'scale(1.3)' }} />
                                                    {rainbowMessage.message}</span>
                                                ) : null
                                            )}
                                        </div>
                                    </div>
                                </div>                                         
                                <div className="content-block">
                                    <div className="block-1">
                                        {getBlock1View(gpAttr)}
                                    </div>
                                    <div className="block-2">
                                        {gpAttr?.attribute.map(attr => {
                                            const isRO = isChecked ? getIsReadOnly(gpAttr, attr) : true
                                            // const { imageaddon, ...filteredAttr } = attr

                                            // Logic for reaving input values based on the unchecking the checkbox.
                                            const updatedAttr = {
                                                ...attr,
                                                ...(selectedDevices[gpAttr.id] === false ? { value: "" } : {}),
                                            }

                                            return <div className="gp-attr">
                                                <UMCAttrComponentView attribute={{
                                                    ...updatedAttr,
                                                    isModalView: true,
                                                    isReadOnly: isRO,
                                                    actionMode: (selectedDevices[gpAttr.id] ? "CREATE" : ""),
                                                    multideviceParam: true,
                                                    resetValidateState : !isChecked,
                                                    ...((attr.buttonaddon && !isChecked) && {
                                                        buttonaddon: {
                                                            ...attr.buttonaddon,
                                                            disabled: isRO
                                                        }
                                                    }),
                                                    ...((selectedDevices[gpAttr.id] === true )? {validateState: validateState} : ""),
                                                    // validateState: validateState,
                                                    // Passing the enable value based on the previous value avaible to restrict unecessary refAPI calling
                                                    enable: baseModalMergeData[0]?.subdomain[0]?.groupattribute
                                                        ?.find(baseGp => (baseGp.id === gpAttr.id && baseGp.enable === true))
                                                        ? false :
                                                        selectedDevices[gpAttr.id]
                                                }} />
                                            </div>

                                        })}
                                    </div>
                                </div>
                            </div>
                        })}
                    </div>
                </>
            })
            }
        </div>
    }


    return <UMCModal
        title={getTranslated(dict, "LABEL_MULTIDEVICE")}
        open={open}
        onOk={() => { }}
        onCancel={handleClose}
        closable={true}
        centered={true}
        content={currModalMergedData && getcontentView(currModalMergedData)}
        footer={getFooter()}
        width={"75%"}
        loading={loading}
        destroyOnClose={true}
    />
}

export default MultideviceModal